var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 mb-6"},[_c('div',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.label))]),_c('AdminCellTimestampReadable',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }